export const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('./views/Login.vue'),
    meta: {
      auth: false,
      layout: 'public',
    },
  },
  {
    path: '/update',
    name: 'UpdateTemporaryPassword',
    component: () => import('./views/UpdateTemporaryPassword.vue'),
    meta: {
      auth: false,
      layout: 'public',
    },
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: () => import('./views/ForgotPassword.vue'),
    meta: {
      auth: false,
      layout: 'public',
    },
    children: [
      {
        path: 'email',
        component: () => import('@/shared/components/ForgotPasswordEmail.vue'),
      },
      {
        path: 'confirmCode',
        component: () => import('@/shared/components/ConfirmPasswordCode.vue'),
      },
    ],
  },
]
